// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as HomeStoreEn$PorterinFeature from "../../domain/store/HomeStoreEn.mjs";
import * as EnterpriseCtaCmp$PorterinFeature from "./EnterpriseCtaCmp.mjs";
import * as EnterpriseTextCmp$PorterinFeature from "./EnterpriseTextCmp.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as EnterpriseGrowthCardBModuleScss from "../styles/EnterpriseGrowthCardB.module.scss";

var styles = EnterpriseGrowthCardBModuleScss;

function EnterpriseGrowthCardCmp(Props) {
  var section_data = Props.section_data;
  if (section_data.content.length <= 0) {
    return null;
  }
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement("div", {
                  className: styles["enterprise-container"]
                }, React.createElement(EnterpriseTextCmp$PorterinFeature.make, {
                      class_name: styles["card-title"],
                      text_content: section_data.section_title
                    }), React.createElement(EnterpriseTextCmp$PorterinFeature.make, {
                      class_name: styles["subtitle-description"],
                      text_content: section_data.content
                    }), React.createElement(EnterpriseCtaCmp$PorterinFeature.make, {
                      class_name: styles["card-cta"],
                      href: section_data.cta.href,
                      text: section_data.cta.text,
                      on_click: (function (param) {
                          PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, HomeStoreEn$PorterinFeature.enterprise_cta_click_b, undefined);
                        })
                    })));
}

var make = EnterpriseGrowthCardCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
